 
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../__generated__/schema.types';

import { CmCollection_CmCollectionImpl_Fragment, CmCollection_CmDynamicListImpl_Fragment, CmCollection_CmGalleryImpl_Fragment, CmCollection_CmQueryListImpl_Fragment, CmCollection_CmSelectionRulesImpl_Fragment, CmCollection_ViewTypeHeroCollection_Fragment } from '../fragments/__generated__/CMCollection.fragment';
import { gql } from '@apollo/client';
import { CmCollectionFragmentDoc } from '../fragments/__generated__/CMCollection.fragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCollectionByIdQueryVariables = Types.Exact<{
  contentId: Types.Scalars['String'];
}>;


export type GetCollectionByIdQuery = { __typename?: 'Query', content?: { __typename?: 'ContentRoot', content?: { __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
      { __typename?: 'CMCollectionImpl' }
      & CmCollection_CmCollectionImpl_Fragment
    ) | { __typename?: 'CMDownloadImpl' } | (
      { __typename?: 'CMDynamicListImpl' }
      & CmCollection_CmDynamicListImpl_Fragment
    ) | { __typename?: 'CMExternalLinkImpl' } | (
      { __typename?: 'CMGalleryImpl' }
      & CmCollection_CmGalleryImpl_Fragment
    ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLinkableImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMLocalizedImpl' } | { __typename?: 'CMMailImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMObjectImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
      { __typename?: 'CMQueryListImpl' }
      & CmCollection_CmQueryListImpl_Fragment
    ) | { __typename?: 'CMResourceBundleImpl' } | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmCollection_CmSelectionRulesImpl_Fragment
    ) | { __typename?: 'CMSettingsImpl' } | { __typename?: 'CMSiteImpl' } | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'Content_Impl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmCollection_ViewTypeHeroCollection_Fragment
    ) | null } | null };


export const GetCollectionByIdDocument = gql`
    query GetCollectionById($contentId: String!) {
  content {
    content(id: $contentId) {
      ...CMCollection
    }
  }
}
    ${CmCollectionFragmentDoc}`;

/**
 * __useGetCollectionByIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetCollectionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionByIdQuery, GetCollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionByIdQuery, GetCollectionByIdQueryVariables>(GetCollectionByIdDocument, options);
      }
export function useGetCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionByIdQuery, GetCollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionByIdQuery, GetCollectionByIdQueryVariables>(GetCollectionByIdDocument, options);
        }
export type GetCollectionByIdQueryHookResult = ReturnType<typeof useGetCollectionByIdQuery>;
export type GetCollectionByIdLazyQueryHookResult = ReturnType<typeof useGetCollectionByIdLazyQuery>;
export type GetCollectionByIdQueryResult = Apollo.QueryResult<GetCollectionByIdQuery, GetCollectionByIdQueryVariables>;